import React from "react";
import { Doughnut } from "react-chartjs-2";

const centerTextPlugin = (label, total) => ({
  id: "centerText",
  beforeDraw(chart) {
    const { width, height, ctx } = chart;
    ctx.save();

    const centerX = width / 2;
    const centerY = height / 2;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    const labelFontSize = height / 25;
    ctx.font = `${labelFontSize}px sans-serif`;
    ctx.fillStyle = "#737373";
    ctx.fillText(label, centerX, centerY - labelFontSize / 1.2);

    const valueFontSize = height / 15;
    ctx.font = `bold ${valueFontSize}px sans-serif`;
    ctx.fillStyle = "#000";
    ctx.fillText(total.toString(), centerX, centerY + valueFontSize / 3);

    ctx.restore();
  },
});

const ChartWithDetails = ({ title, labels, values, colors }) => {
  const total = values.reduce((a, b) => a + b, 0);

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 2,
      },
    ],
  };

  return (
    <div className="graph-parameter">
      <div className="circle-graph" style={{ width: "250px" }}>
        <Doughnut
          data={data}
          options={{
            plugins: {
              legend: { display: false },
              tooltip: { enabled: true },
            },
          }}
          plugins={[centerTextPlugin("Total Value", total)]}
        />
      </div>

      <div className="graph-table">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "0 0 0 25px" }}>
                Label
              </th>
              <th>Value</th>
              <th style={{ textAlign: "right", padding: "0 10px 0 0" }}>%</th>
            </tr>
          </thead>
          <tbody>
            {labels.map((label, i) => {
              const percentage =
                total > 0 ? ((values[i] / total) * 100).toFixed(1) : 0;
              return (
                <tr key={label}>
                  <td style={{ textAlign: "left" }}>
                    <span
                      className="circle"
                      style={{
                        display: "inline-block",
                        width: "12px",
                        height: "12px",
                        backgroundColor: colors[i],
                        marginRight: "6px",
                      }}
                    ></span>
                    {label}
                  </td>
                  <td>{values[i]}</td>
                  <td style={{ textAlign: "right" }}>{percentage}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChartWithDetails;
